import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type BadgeDetails as SchemaBadgeDetails } from '../schemas/BadgeDetails';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Badges
 */
export const GetBadgeContentType = '' as const;
export type GetBadgeRequest = void;
export type GetBadgeResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of badge
     */
    '200': {
        'application/json': SchemaBadgeDetails;
    };
};
export type GetBadgeResponseSuccess = GetBadgeResponses['200']['application/json'];
export type GetBadgeSearchParams = undefined;
export type GetBadgePathParameters = {
    id: string;
};
export const GetBadgeUrl = '/badges/{id}' as const;
export const GetBadgeMethod = 'GET' as const;
export const getGetBadgeUrl = (params: GetBadgePathParameters) =>
    GetBadgeUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetBadgePathParameters) => String(params[param]));
